import { Component, OnDestroy } from '@angular/core';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SearchService } from '../../../search/search.service';
import { SearchParams } from '../../../search/models/search-params.model';
import { SearchStatus } from '../../../search/models/search-status.model';
import { ResourceService } from 'sce-core';
import { INVENTORY_LOOKUP } from '../../../../features/inventory/vas/kitting/kitting.constants';
import { SORT_ORDER_DESC } from '../../../search/search-constants';


@Component({
  selector: 'lfwms-status-logs-popup',
  templateUrl: './status-logs-popup.component.html',
  styleUrls: ['./status-logs-popup.component.css']
})
export class StatusLogsPopupComponent implements OnDestroy {


  public parentDataService: any;
  public isLoading: boolean = true;
  private searchParams: SearchParams;
  private searchStatus: SearchStatus;
  private searchService: SearchService;
  public resourceService: ResourceService;


  constructor(private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry) {
      this.resourceService = coreServiceRegistry.resourceService;
  }

  public initialize(datatableId: string, searchCriteria: any) {
    this.searchParams = new SearchParams();
    this.searchParams.tableId = datatableId;
    this.searchParams.isFullFetch = true;
    this.searchStatus = new SearchStatus();
    this.searchService = this.sharedServiceRegistry
      .createSearchService(this.searchParams, this.searchStatus);
    this.searchService.fetchMetadata()
      .subscribe(() => {
        this.searchService.pagedData.pageDefinition.sortColumn = INVENTORY_LOOKUP.STATUS_LOG_SORT_COLUMN;
        this.searchService.pagedData.pageDefinition.sortOrder = SORT_ORDER_DESC;
        this.searchService.setSearchCriteria(searchCriteria);
        this.searchService.performSearch();
        this.isLoading = false;
      });
  }


  public ngOnDestroy() {
    // Memory Cleanup
    this.searchService = null;

  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/common/status-logs-popup/status-logs-popup.component.ts